import { apiGet, apiPatch, apiPut } from "@/lib/api";
import type {
  ContentFilterConfig,
  ReportAction,
  ReportListResponse,
  ReportResponse,
  ReportStatus,
} from "./types";

export const ADMIN_REPORTS_PATH = "/v1/admin/reports";
export const ADMIN_CONTENT_FILTER_PATH = "/v1/admin/content-filter";

export function listAdminReports(status: ReportStatus = "open"): Promise<ReportListResponse> {
  return apiGet<ReportListResponse>(`${ADMIN_REPORTS_PATH}?status=${encodeURIComponent(status)}`);
}

export function getAdminReport(id: string): Promise<ReportResponse> {
  return apiGet<ReportResponse>(`${ADMIN_REPORTS_PATH}/${encodeURIComponent(id)}`);
}

export function patchAdminReport(
  id: string,
  action: ReportAction,
  note?: string,
): Promise<ReportResponse> {
  const body: { action: ReportAction; note?: string } = { action };
  if (note && note.trim()) body.note = note.trim();
  return apiPatch<ReportResponse>(`${ADMIN_REPORTS_PATH}/${encodeURIComponent(id)}`, body);
}

export function getContentFilter(): Promise<ContentFilterConfig> {
  return apiGet<ContentFilterConfig>(ADMIN_CONTENT_FILTER_PATH);
}

export function putContentFilter(config: ContentFilterConfig): Promise<ContentFilterConfig> {
  return apiPut<ContentFilterConfig>(ADMIN_CONTENT_FILTER_PATH, {
    enabled: config.enabled,
    terms: config.terms,
  });
}
